import React from 'react';

import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { Typography } from '@material-ui/core';

import { IFillRowStyles } from '../../../redux/layers/layerTypes';

type FillRowProps = {
  style: IFillRowStyles;
};

function FillRow({ style }: FillRowProps) {
  const classes = useStyles();
  const color = style.color || '#000';
  const isBorder = style.borderColor || style.borderWidth;
  const borderColor = style.borderColor || '#000';
  const borderWidth = style.borderWidth || 1;

  return (
    <div className={classes.root}>
      <div
        className={classes.fill}
        style={{
          backgroundColor: color,
          ...(isBorder ? { border: `${borderWidth}px solid ${borderColor}` } : {}),
          ...style.styles
        }}
      />
      <Typography className={classes.label} variant="caption" color="textPrimary">
        {style.label || style.name}
      </Typography>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center'
    },
    label: {
      marginLeft: 10,
      fontSize: 10
    },
    fill: {
      width: 10,
      height: 10,
      flexShrink: 0
    }
  })
);

export default FillRow;
